exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/rebates/edit-rebate/edit-rebate.component.scss
// module id = ../../../../../angular/app/components/rebates/edit-rebate/edit-rebate.component.scss
// module chunks = 1